export default {
  GET_ANONYMOUS_LEAD_REQUEST: '@@opt-out/GET_ANONYMOUS_LEAD_REQUEST',
  GET_ANONYMOUS_LEAD_SUCCESS: '@@opt-out/GET_ANONYMOUS_LEAD_SUCCESS',
  GET_ANONYMOUS_LEAD_ERROR: '@@opt-out/GET_ANONYMOUS_LEAD_ERROR',

  UPDATE_ANONYMOUS_LEAD_REQUEST: '@@opt-out/UPDATE_ANONYMOUS_LEAD_REQUEST',
  UPDATE_ANONYMOUS_LEAD_SUCCESS: '@@opt-out/UPDATE_ANONYMOUS_LEAD_SUCCESS',
  UPDATE_ANONYMOUS_LEAD_ERROR: '@@opt-out/UPDATE_ANONYMOUS_LEAD_ERROR',
};
